import React from 'react';
const Textarea = React.memo((props) => {
    var _a;
    return (React.createElement("textarea", { className: `${props.optionClass ? props.optionClass : ""} text-sm text-gray-700 placeholder-gray-600 bg-gray-100 rounded-md focus:placeholder-gray-500 focus:bg-white focus:outline-none focus:shadow-outline-red border py-2 px-3 appearance-none resize-none`, placeholder: props.placeholder, value: (_a = props.inputValue) !== null && _a !== void 0 ? _a : "", rows: 5, disabled: props.disabled, name: props.name, onChange: props.onChange }));
});
export default Textarea;
